import React, { FC } from 'react';
import { Row, Col } from 'antd';
import InputField from 'shared/components/InputField';
import styles from '../../activityDataEntry.module.scss';
import { Scope2DesiredData } from 'models/ActivityDataScope2DesiredData/scope2DesiredData.model';
import { ScopeData } from 'models/ActivityDataEntryScopes/scopes.model';
import { useFormikContext } from 'formik';
import { HelpDeskInputFieldEnum } from 'context/HelpDeskTooltipContext/helpDeskInputFieldEnum';
import { marketBasedRECField } from 'constants/constants';
import { convertToReadableText } from 'shared/utils/convertToUserReadable';

interface MarketBasedFieldsProps {
  handleToolTipOpen: (fieldName: HelpDeskInputFieldEnum) => () => void;
  isEditView: boolean;
  handleMonthlyModalOpen: (
    source?: ScopeData,
    key?: string,
    selectedIndex?: string
  ) => () => void;
  handleSwitch: (
    source?: ScopeData,
    key?: string,
    selectedIndex?: string
  ) => () => void;
}

const MarketBasedFields: FC<MarketBasedFieldsProps> = ({
  handleToolTipOpen,
  isEditView,
  handleMonthlyModalOpen,
  handleSwitch,
}) => {
  // TODO All commented code i'll uncomment after client approval
  const marketBasedRecFields = [
    {
      label: 'REC Provider Name',
      name: 'providerName',
      placeholder: 'REC Provider Name',
      helpdesk: 'provider_name',
    },
    {
      label: 'Certificate Number',
      name: 'certificateNumber',
      placeholder: 'Certificate Number',
      helpdesk: 'certificate_number',
    },
    {
      label: 'Emission Factor (kg CO2e per kWh) as per REC',
      name: 'emissionValue',
      placeholder: 'Emission Factor (kg CO2e per kWh) as per REC',
      helpdesk: 'emission_value',
    },
  ];
  const { values } = useFormikContext<Scope2DesiredData>();
  return (
    <Row gutter={[24, 40]} className={styles.mobileSourceFormConatiner}>
      {values?.marketBased?.map((marketBasedItem, index) => (
        <Col span={12} key={marketBasedItem.fuelName}>
          <div className={styles.fieldContainer}>
            <Col span={values?.marketBased?.[index].isYearly ? 16 : 9}>
              <InputField
                name={`marketBased.${index}.fuelValue`}
                placeholderstring={marketBasedItem?.getPlaceholder?.() ?? ''}
                label={marketBasedItem?.getPlaceholder?.() ?? ''}
                // info
                // infoClick={handleToolTipOpen(
                //   convertToReadableText(
                //     marketBasedItem?.fuelName
                //   ) as HelpDeskInputFieldEnum
                // )}
                // disabled={!isEditView || !values?.marketBased?.[index].isYearly}
                disabled
                isNullable
              />
            </Col>
            {/* {
              // TODO: Will enable once client add this option in future
              !values?.marketBased?.[index].isYearly && (
                <>
                  <Col span={7}>
                    <p
                      className={styles.viewMonthlyText}
                      onClick={handleMonthlyModalOpen(
                        values?.marketBased?.[index],
                        'marketBased',
                        `marketBased[${index}]`
                      )}>
                      View Monthly data
                    </p>
                  </Col>
                  {isEditView && (
                    <span className={styles.pipeSeperator}> | </span>
                  )}
                </>
              )
            }
            {isEditView && (
              <Col span={8}>
                <p
                  className={styles.monthlyText}
                  onClick={handleSwitch(
                    values?.marketBased?.[index],
                    'marketBased',
                    `marketBased[${index}]`
                  )}>
                  {values?.marketBased?.[index].isYearly
                    ? 'Switch to monthly'
                    : 'Switch to annually'}
                </p>
              </Col>
            )} */}
          </div>
          {/* Un comment after client give confirmation */}
          {/* <Row gutter={[24, 40]} className={styles.recField}>
            {marketBasedItem?.fuelName === marketBasedRECField &&
              marketBasedRecFields.map(field => (
                <Col span={8} key={field.name}>
                  <InputField
                    name={`marketBased.${index}.electricityFromRec.${field.name}`}
                    placeholderstring={field.placeholder}
                    label={field.label}
                    info
                    infoClick={handleToolTipOpen(
                      field.helpdesk as HelpDeskInputFieldEnum
                    )}
                    disabled={
                      !isEditView 
                    }
                  />
                </Col>
              ))}
          </Row>
          {marketBasedItem?.fuelName === marketBasedRECField && (
            <div className={styles.seperator}>
              <hr />
            </div>
          )} */}
        </Col>
      ))}
    </Row>
  );
};

export default MarketBasedFields;